import { createFileRoute } from "@tanstack/react-router";
import { StaffPage } from "@/components/staff/staff-page";

export const Route = createFileRoute("/_app/staff")({
  component: StaffPage,
});
